import apiExpedition from '@/api/logistic/expedition';
// import apiOption from '@/api/logistic/option';

const defaultState = () => ({
	listExpedition: [],
	detailExpedition: {},
	expeditionPagination: '',
});

const state = defaultState();

const getters = {

};

const mutations = {

	setExpedition(state, data) {
		state.listExpedition = data.data
		state.expeditionPagination = data.pagination;
	},
	
};

const actions = {
	getExpedition({ commit }, params) {
		apiExpedition.getExpedition(params).then(({ data: { data } }) => {
			commit('setExpedition', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setExpedition', { data: [], pagination: {} });
		});
	},
	
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};